import { create } from 'zustand';

/**
 * App-open lock. `unlocked` is session-scoped (in-memory only) so it resets every
 * time the mini app is (re)launched — a user with a PIN or biometric enabled must
 * re-authenticate on every open. Send/seed keep their own per-action reauth on
 * top of this; unlocking the app does NOT authorize those.
 */
interface LockState {
  unlocked: boolean;
  unlock: () => void;
  lock: () => void;
}

export const useLock = create<LockState>((set) => ({
  unlocked: false,
  unlock: () => set({ unlocked: true }),
  lock: () => set({ unlocked: false }),
}));
